const objSort = function objSort(property) {
  let sortOrder = 1;
  let sortProperty = property;
  if (property[0] === '-') {
    sortOrder = -1;
    sortProperty = property.substr(1);
  }
  return function internalSort(a, b) {
    let result = 0;
    if (a[sortProperty] < b[sortProperty]) {
      result = -1;
    } else if (a[sortProperty] > b[sortProperty]) {
      result = 1;
    }
    return result * sortOrder;
  };
};

/**
 * Calculate the best-of format based on series data
 * @param {Object} series - The series object containing team scores and match data
 * @returns {string} - The best-of format (e.g., "BO1", "BO3", "BO5")
 */
const getBestOfFormat = function getBestOfFormat(series) {
  // Handle undefined or invalid series
  if (!series) {
    return 'BO?';
  }

  // If we have team scores, calculate based on total possible maps
  if (series.team1 && series.team2 && series.team1.score && series.team2.score) {
    const team1Score = parseInt(series.team1.score) || 0;
    const team2Score = parseInt(series.team2.score) || 0;
    const totalMaps = team1Score + team2Score;

    // Determine format based on total maps played
    if (totalMaps === 1) return 'BO1';
    if (totalMaps === 2) return 'BO3'; // 2-0 or 1-1 (incomplete BO3)
    if (totalMaps === 3) return 'BO3'; // 2-1 or 3-0 (complete BO3)
    if (totalMaps === 4) return 'BO5'; // 3-1 (complete BO5)
    if (totalMaps === 5) return 'BO5'; // 3-2 (complete BO5)

    // For other cases, try to determine from match_count
    if (series.match_count) {
      const matchCount = parseInt(series.match_count);
      if (matchCount === 1) return 'BO1';
      if (matchCount === 2) return 'BO3'; // Most likely BO3 with 2 matches
      if (matchCount === 3) return 'BO3';
      if (matchCount === 4) return 'BO5'; // Most likely BO5 with 4 matches
      if (matchCount === 5) return 'BO5';
    }

    return `BO${totalMaps}`;
  }

  // Fallback to match_count if available
  if (series.match_count) {
    const matchCount = parseInt(series.match_count);
    if (matchCount === 1) return 'BO1';
    if (matchCount === 2) return 'BO3'; // Most likely BO3
    if (matchCount === 3) return 'BO3';
    if (matchCount === 4) return 'BO5'; // Most likely BO5
    if (matchCount === 5) return 'BO5';
    return `BO${matchCount}`;
  }

  return 'BO?';
};

export default objSort;
export {
  objSort,
  getBestOfFormat,
};
